import React, {FunctionComponent} from 'react';

interface IQrCodeControls {
    qrTitle: string;
    showEmailButton: boolean;
    onEmailClick: () => void;
    onLinkClick: () => void;
}

const QrCodeControls:FunctionComponent<IQrCodeControls> = ({qrTitle, onEmailClick, onLinkClick, showEmailButton}) => {
    return (
        <div className="col-md-6">
            <div className="row pt-5">
                <div className="visible-md visible-lg text-left col-md-offset-1">
                    <p className="qr-text float-left">{ qrTitle }</p>
                </div>
            </div>
            <div className="link-group">
                <div className="row">
                    <div className="col-md-offset-1">
                        <div className="photo-route-btn text-md-center">
                            {
                                showEmailButton &&
                                <button
                                    className="btn btn-primary btn-form mr-10"
                                    onClick={onEmailClick}
                                >
                                    <i className="icon-mail5 icon-size"/>
                                </button>
                            }
                            <button
                                className="btn btn-primary btn-form mr-10"
                                onClick={onLinkClick}
                            >
                                <i className="icon-link icon-size" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="hidden-md hidden-lg text-center pt-5">
                <p className="qr-text float-left">{ qrTitle }</p>
            </div>
        </div>
    )
};

export default QrCodeControls;
